<template>
  <div>
    <header>
      <myheader></myheader>
    </header>
    <div>
      <router-view></router-view>
    </div>
    <myfooter></myfooter>
  </div>
</template>

<script>

  import myheader from './Header.vue'
  import myfooter from './Footer.vue'

export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    myheader,
    myfooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Home.vue